var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconQuickLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 12,
  viewBox: "0 0 11 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 0L11 5H0zm0 12L11 7H0z",
  fillRule: "evenodd"
})));
export default SvgIconQuickLink;